import * as React from "react";
import { SVGProps } from "react";
export function TrashIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={14}
      height={14}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#trash_svg__a)">
        <path
          d="m11.083 4.083-.672 7.055c-.045.544-.5.945-1.047.945H4.636a1.034 1.034 0 0 1-1.047-.945l-.672-7.055m2.916 2.334v3.5m2.334-3.5v3.5m.583-5.834v-1.75a.586.586 0 0 0-.583-.583H5.833a.586.586 0 0 0-.583.583v1.75m-2.917 0h9.334"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="trash_svg__a">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
